export default "/images/phone.svg?22904118b466d50710a6927da97da9cf";